import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@/utils/fn';

export default class Treatment {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.appointmentId = args.appointmentId;
		this.appointmentSalesLineId = args.appointmentSalesLineId;
		this.bookingSortNo = args.bookingSortNo || 0;
		this.campaignId = args.campaignId || 0;
		this.description = args.description || '';
		this.durationInMinutes = args.durationInMinutes || args.durationMinutes || args.time || 0;
		this.employeeId = args.employeeId || '';
		this.employeeInitials = args.employeeInitials || '';
		this.employeeImageUrl = args.employeeImageUrl || '';
		this.employeeName = args.employeeName || args.employeeFirstName || '';
		this.ftcCategoryId = args.ftcCategoryId || 0;
		this.ftcCategoryImgUrls = args.ftcCategoryImgUrls;
		this.hasBought = !!args.hasBought;
		this.notBookable = !!args.notBookable;
		this.onlineTreatmentTime = args.onlineTreatmentTime || 0;
		this.popularity = args.popularity || 0;
		this.price = args.price || args.itemPrice || 0;
		this.relatedTreatments = args.relatedTreatments || [];
		this.saleBonuspointsEarned = args.saleBonuspointsEarned || args.bonusPointsEarned || 0;
		this.saleBonuspointsUsed = args.saleBonuspointsUsed || args.bonusPointsUsed || 0;
		this.treatmentCategoryId = args.treatmentCategoryId || '';
		this.treatmentId = args.id || args.treatmentId || args.treatmentOrProductId || '';
		this.treatmentName = args.treatmentName || args.itemName || args.name || '';
		this.treatmentTime1 = (args.treatmentTime1 || '').match(/^(\d+):(\d+):(\d+)$/g) ? args.treatmentTime1 : moment(args.treatmentTime1 || '').format('LTS');
		this.treatmentTime2 = (args.treatmentTime2 || '').match(/^(\d+):(\d+):(\d+)$/g) ? args.treatmentTime2 : moment(args.treatmentTime2 || '').format('LTS');
		this.treatmentTimePattern = args.treatmentTimePattern || '';
		this.waitingTime = (args.waitingTime || '').match(/^(\d+):(\d+):(\d+)$/g) ? args.waitingTime : moment(args.waitingTime || '').format('LTS');
	}
}

export class TreatmentCategory {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.categoryName = args.categoryName || '';
		this.description = args.description || '';
		this.ftcCategoryName = args.ftcCategoryName || '';
		this.sortNumber = args.sortNumber || 0;
		this.treatmentCategoryId = args.treatmentCategoryId || '';
		this.treatments = (args.treatments || []).map(treatment => new Treatment({ ...treatment, ...{ treatmentCategoryId: args.treatmentCategoryId } }));
	}
}

export class TreatmentFilter {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.name = args.name || '';
		this.metaTitle = args.metaTitle || '';
		this.metaDescription = args.metaDescription || '';
		this.description = args.description || '';
		this.url = args.url || '';
		this.fixitCategoryId = args.fixitCategoryId || 0;
		this.fixitTreatmentId = args.fixitTreatmentId || 0;
		this.showLandingPageForAllAreas = !!args.showLandingPageForAllAreas;
		this.showLandingPageForMainAreas = !!args.showLandingPageForMainAreas;
		this.image = args.image;
		this.imageUrls = args.imageUrls || [];
		this.shouldBeDisplayedAsLandingPage = !!args.shouldBeDisplayedAsLandingPage;
		this.treatments = (args.children || []).map(treatment => new TreatmentFilter(treatment));
	}
}
